import async from 'async';
import _get from 'lodash/get';

import { get } from 'utils';
import { getUrlParameter } from 'utils/methods';
import loadCSSVariablesPolyfill from 'config/polyfills/cssVariables';

// Fetch store properties for retailer
export default function fetchStoreProperties(success, error) {
  const params = {};
  const location = window.location.search;

  const retailer = (getUrlParameter(location, 'retailer') || '').toLowerCase();
  if (retailer && retailer.length) {
    params.retailer = retailer;
  } else {
    params.domain = (window.location || {}).hostname;
  }

  const fetchUpdateStoreProperties = async callback => {
    try {
      const endpoint = `/customer/storeProperties/`;
      const data = await get(endpoint, { isPublic: true, params });
      callback(null, data);
    } catch (e) {
      callback(e, null);
    }
  };

  async.retry(
    {
      times: 3,
      interval: 3000,
      errorFilter: err => _get(err, 'statusCode') !== 404
    },
    fetchUpdateStoreProperties,
    function(err, result) {
      if (err) {
        const errorObject = new Error(`GET Store properties Failed: ${params}`);
        errorObject.source = 'storeProperties';
        errorObject.searchParams = params;
        errorObject.statusCode = _get(err, 'statusCode');
        error(errorObject);
      } else {
        const data = _get(result, 'data');
        if (!data) {
          throw new Error('No data to process');
        }
        loadCSSVariablesPolyfill(JSON.stringify(data));
        success(JSON.stringify(data));
      }
    }
  );
}
